import React, {useEffect, useState} from "react"
import {compose, withProps, withStateHandlers} from "recompose"
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps"
import ProviderSlider from "./ProviderSlider";
import marker from "../images/marker.svg"
import markerActive from "../images/marker_active.svg"

const MyMapComponent = compose(
    withStateHandlers(({goToSlide}) => ({
        isOpen: false,
        goToSlide: goToSlide,
        markerPosition: false,
        markerClicked: false,
        providers: []
    }), {
        onToggleOpen: () => (position) => ({
            markerPosition: position,
            markerClicked: true
        }),
        setCurrentMarker: (props) => (key) => ({
            markerPosition: {
                lat: props.providers[key] ? parseFloat(props.providers[key].lat) : 0,
                lng: props.providers[key] ? parseFloat(props.providers[key].lng) : 0
            },
            markerClicked: true
        }),
        setProviders: () => (data) => ({
            providers: data
        })
    }),
    withProps(props => ({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBHTS-SI6AQIuEVRqOiSwhUBd-BPHTKpdI&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{height: `100%`}}/>,
        containerElement: <div style={{height: `42vh`}}/>,
        mapElement: <div style={{height: `100%`}}/>,
        goToSlide: props.goToSlide
    })),
    withScriptjs,
    withGoogleMap,
)((props) => {
    useEffect(() => {
        if (props.currentSlide !== false) {
            props.setCurrentMarker(props.currentSlide)
        }
    }, [props.currentSlide])
    useEffect(() => {
        if (props.physiciansData !== undefined && props.physiciansData.length) {
            props.setProviders(props.physiciansData)

        }
    }, [props.physiciansData])

    return <GoogleMap

        defaultZoom={8}
        zoom={props.markerClicked ? 13 : 8}
        center={props.markerClicked ? props.markerPosition : {
            lat: props.providers.length ? parseFloat(props.providers[0].lat) : 0,
            lng: props.providers.length ? parseFloat(props.providers[0].lng) : 0
        }}
    >
        {
            props.providers !== undefined && props.providers.length ?
                props.providers.map((provider, key) => {
                    const markerPosition = {lat: parseFloat(provider.lat), lng: parseFloat(provider.lng)}
                    return <MarkerPureComponent title={provider.name.toString()}
                                                index={key}
                                                markerPosition={markerPosition}
                                                onMarkerClick={props.onMarkerClick}
                                                onToggleOpen={props.onToggleOpen}
                                                isActive={(key === props.currentSlide) || (!key && !props.currentSlide)}/>
                }) : <></>
        }
    </GoogleMap>
})

const Map = () => {
    const [isMarkerShown, setIsMarkerShown] = useState(false)
    const [currentSlide, setCurrentSlide] = useState(false)
    const [goToSlide, setGoToSlide] = useState(false)
    const [markerPosition, setMarkerPosition] = useState(false)
    const [physiciansData, setPhysiciansData] = useState([])
    useEffect(() => {
        delayedShowMarker()
        window.addEventListener("message", (e) => {
            setPhysiciansData(e.data.value)
        });
    }, [])
    const delayedShowMarker = () => {
        setTimeout(() => {
            setIsMarkerShown(true)
        }, 1000)
    }

    const handleMarkerClick = (key, markerPosition) => {
        setGoToSlide(key)
        setMarkerPosition(markerPosition)
    }
    const onSlide = (key) => {
        setCurrentSlide(key)
    }
    return (
        <div>
            <MyMapComponent
                isMarkerShown={isMarkerShown}
                onMarkerClick={handleMarkerClick}
                markerPosition={markerPosition}
                currentSlide={currentSlide}
                physiciansData={physiciansData}
            />
            <div className={"map-slider"}>
                <ProviderSlider data={{
                    fromMap: true,
                    goToSlide: goToSlide,
                    onSlide: onSlide,
                    providers: physiciansData
                }}/>
            </div>
        </div>
    )
}
const MarkerPureComponent = ({title, index, markerPosition, onMarkerClick, onToggleOpen, isActive}) => {
    let iconMarker = new window.google.maps.MarkerImage(
        isActive ? markerActive : marker,
        null, /* size is determined at runtime */
        null, /* origin is 0,0 */
        null, /* anchor is bottom center of the scaled image */
        new window.google.maps.Size(32, 32)
    );
    return (
        <Marker
            title={title.toString()}
            key={index}
            position={markerPosition}
            icon={iconMarker}
            onClick={() => {
                onMarkerClick(index, markerPosition);
                onToggleOpen(markerPosition)
            }}
            zIndex={isActive?10000:100}

        />
    )
}
export default Map;